module.exports = __webpack_public_path__ + "media/images/logo-new-148a2333c48700cd3823b3aa9f9db885.svg";